export default __webpack_public_path__ + "static/media/pdl_large_logo.51e687b4.png";